import { NavLink } from 'react-router-dom';
import vistaLogo from '../../assets/vista-logo.svg';

const NAV_ITEMS = [
  { to: '/', label: 'Organizations', icon: '⊞' },
  { to: '/platform-users', label: 'Platform Users', icon: '⊕' },
  { to: '/platform-health', label: 'Platform Health', icon: '♡' },
  { to: '/releases', label: 'Releases', icon: '⤓' },
];

export default function Sidebar() {
  return (
    <aside className="flex w-56 flex-col border-r border-gray-200 bg-white">
      <div className="flex h-14 items-center gap-2 border-b border-gray-200 px-3">
        <img src={vistaLogo} alt="VISTA" className="h-8" />
        <span className="rounded bg-blue-100 px-1.5 py-0.5 text-xs font-semibold text-blue-700">Admin</span>
      </div>
      <nav className="flex-1 space-y-0.5 p-2">
        {NAV_ITEMS.map(({ to, label, icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`
            }
          >
            <span className="w-5 text-center">{icon}</span>
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
